import { Route, Routes, useNavigate } from 'react-router-dom'
import React, { lazy } from 'react'
import { useAppSelector } from '../hooks'
import { permissionsUser } from '../store/selectors'
import { ROUTES } from './const'

const PMProfile = lazy(() => import('pages/PMProfile'))
const PMPage = lazy(() => import('pages/PmPage'))

const PMsRoutes = () => {
    const navigate = useNavigate()
    const { isSuperAdmin } = useAppSelector(permissionsUser)

    if (isSuperAdmin) {
        navigate(ROUTES.DASHBOARD)
    }
    return (
        <Routes>
            <Route index element={<PMPage />} />
            <Route path="/:id" element={<PMProfile />} />
        </Routes>
    )
}

export default PMsRoutes
